import { createSelector } from 'reselect';

import { partnershipsByIdSelector } from 'selectors/partnershipsSelectors';
import { idParamSelector } from 'selectors/routerSelectors';

export const partnershipFromParamSelector = createSelector(
  [partnershipsByIdSelector, idParamSelector],
  (partnerships, partnershipId) => partnerships[partnershipId],
);
